import React from 'react';
import { QqOutlined, UserOutlined } from '@ant-design/icons';
import UserRole from '../routers/UserRole';
import UserList from '../routers/UserList';
import KLine from '../routers/KLine';
import RefData from '../routers/RefData';
import MockPage from '../routers/MockPage';

export const AUTH = {
  USER_LIST: { 'key': 'user_list', 'title': '用户列表' },
  USER_ROLE: { 'key': 'user_role', 'title': '用户角色' },
  HK_KLINE: { 'key': 'hk_kline', 'title': '港股 K 线' },
  US_KLINE: { 'key': 'us_kline', 'title': '美股 K 线' },
  MIGRATION: { 'key': 'start_migration', title: '迁移 K 线' },
  REF_DATA: { 'key': 'ref_data', title: 'refData 页面' },
  REF_DATA_DELETE: { 'key': 'ref_data_delete', title: 'refData 页面删除功能' },
  MOCK_PAGE: { 'key': 'mock_page', title: 'mock 页面' },
};

export const menu_list = [
  {
    key: 'user',
    title: '用户列表',
    icon: <UserOutlined />,
    children: [
      {
        auth: [AUTH.USER_LIST],
        title: '用户列表',
        router: '/user/list',
        com: UserList,
      },
      {
        auth: [AUTH.USER_ROLE],
        title: '用户角色',
        router: '/user/role',
        com: UserRole,
      },
    ]
  },
  {
    key: 'marketdata',
    title: '行情',
    icon: <QqOutlined />,
    children: [
      {
        title: 'K线图',
        router: '/kline',
        auth: [AUTH.HK_KLINE, AUTH.US_KLINE, AUTH.MIGRATION],
        // auth_title: '港股 K 线,美股 K 线',
        com: KLine,
      },
      {
        title: 'RefData',
        router: '/refdata',
        auth: [AUTH.REF_DATA, AUTH.REF_DATA_DELETE],
        com: RefData,
      },
      {
        title: 'MOCK',
        router: '/mockpage',
        auth: [AUTH.MOCK_PAGE],
        com: MockPage,
      }
    ]
  }
];
